define('notifications',["jquery", "underscore", "knockout", "api", "i18n"], function ($, _, ko, api, i18n) {
    return function (application) {
        var me = this;
        var lastHandledTappedNotificationKey = null;

        var isApnPluginAvailable = function () {
            return !!(window.cordova && window.cordova.platformId === "ios" && window.VegZonePushNotificationsPlugin);
        };

        var isFirebasePluginAvailable = function () {
            return !!window.FirebasePlugin;
        };

        var internalIsEnabled = function () {
            return (window.localStorage.getItem("VzPushNotificationsEnabled") || "0") === "1";
        };

        var createDeviceDescriptor = function () {
            return {
                Manufacturer: window.device ? window.device.manufacturer : null,
                Model: window.device ? window.device.model : null,
                Platform: window.device ? window.device.platform : null
            };
        };

        var registerDevice = function (deviceData) {
            api.post("/api/account/device", JSON.stringify(deviceData))
                .done(function (result) {
                    console.log("token registration result", result);
                })
                .fail(function (error) {
                    console.log("Failed to register device token", error);
                });
        };

        var getTappedNotificationKey = function (notification) {
            return notification.notification_vz_id || notification.navigate_to || JSON.stringify(notification);
        };

        var handleNotificationMessage = function (message, tapped) {
            try {
                var payload = message && message.payload ? message.payload : (message || {});
                var notification = _.extend({}, payload, {
                    tap: tapped === true || payload.tap === true || payload.tap === "true" || payload.tap === "background"
                });

                if (notification.tap) {
                    var notificationKey = getTappedNotificationKey(notification);
                    if (notificationKey && notificationKey === lastHandledTappedNotificationKey) {
                        return;
                    }

                    lastHandledTappedNotificationKey = notificationKey;
                }

                if (typeof application.loadUserState === "function") {
                    application.loadUserState();
                }

                if (application.events && typeof application.events.fire === "function") {
                    application.events.fire("pushNotificationMessageReceived", notification);
                }

                if (notification.tap) {
                    if (notification.notification_vz_id) {
                        api.post("/api/account/notifications/" + notification.notification_vz_id + "/displayed")
                            .done(function () {
                                if (typeof application.loadUserState === "function") {
                                    application.loadUserState();
                                }
                            });
                    }

                    if (notification.navigate_to) {
                        application.navigation.navigate(notification.navigate_to);
                    }
                }
            } catch (e) {
                console.log("Exception in push notification callback: " + e.message);
            }
        };

        var registerApnNotifications = function () {
            VegZonePushNotificationsPlugin.register(function (granted) {
                if (!granted) {
                    console.log("Notifications won't be shown as permission is denied");
                    me.isEnabled(false);
                }
            }, function (error) {
                console.log("Failed to register for APNs", error);
                me.isEnabled(false);
            });
        };

        if (isApnPluginAvailable()) {
            document.addEventListener("apn.token", function (event) {
                registerDevice($.extend(createDeviceDescriptor(), {
                    ApnToken: event.token
                }));
            });

            document.addEventListener("apn.notification", function (event) {
                handleNotificationMessage(event, false);
            });

            document.addEventListener("apn.notificationTapped", function (event) {
                handleNotificationMessage(event, true);
            });

            document.addEventListener("apn.registrationError", function (event) {
                console.log("APNs registration failed", event.message || event);
            });

            // Wait for the application bootstrap to finish before replaying queued native events.
            window.setTimeout(function () {
                VegZonePushNotificationsPlugin.flushPendingEvents(function () {
                }, function (error) {
                    console.log("Failed to flush pending APNs events", error);
                });
            }, 0);
        }

        this.isEnabled = ko.observable(internalIsEnabled());

        this.isEnabled.subscribe(function (value) {
            window.localStorage.setItem("VzPushNotificationsEnabled", value ? "1" : "0");

            if (value) {
                if (isApnPluginAvailable()) {
                    registerApnNotifications();
                } else if (isFirebasePluginAvailable()) {
                    FirebasePlugin.setAutoInitEnabled(true);
                    me.sendTokenToApi();
                }
            } else {
                if (isApnPluginAvailable()) {
                    VegZonePushNotificationsPlugin.unregister();
                } else if (isFirebasePluginAvailable()) {
                    FirebasePlugin.unregister();
                }
            }
        });

        this.sendTokenToApi = function () {
            if (!internalIsEnabled()) {
                return;
            }

            if (isApnPluginAvailable()) {
                VegZonePushNotificationsPlugin.checkPermission(function (status) {
                    if (status === "denied") {
                        console.log("Notifications won't be shown as permission is denied");
                        me.isEnabled(false);
                        return;
                    }

                    registerApnNotifications();
                }, function (error) {
                    console.log("Failed to check APNs permission", error);
                });

                return;
            }

            if (!isFirebasePluginAvailable()) {
                return;
            }

            var checkNotificationPermission = function (requested) {
                window.FirebasePlugin.hasPermission(function (hasPermission) {
                    if (hasPermission) {
                        console.log("Remote notifications permission granted");

                        window.FirebasePlugin.getToken(function (token) {
                            console.log("Got FCM token: " + token);
                            registerDevice($.extend(createDeviceDescriptor(), {
                                FcmToken: token
                            }));
                        }, function (error) {
                            console.log("Failed to get FCM token", error);
                        });
                    } else if (!requested) {
                        console.log("Requesting remote notifications permission");
                        FirebasePlugin.grantPermission(checkNotificationPermission.bind(this, true));
                    } else {
                        console.log("Notifications won't be shown as permission is denied");
                        me.isEnabled(false);
                    }
                });
            };

            checkNotificationPermission(false);
        };

        if (isFirebasePluginAvailable()) {
            FirebasePlugin.createChannel({
                    id: "sendy_channel",
                    name: "Sendy",
                    description: i18n.t("Frontend.CheckinNotificationChannelDescription"),
                    sound: "pigeon",
                    vibration: true,
                    light: true,
                    lightColor: -1,
                    importance: 4,
                    badge: true,
                    visibility: 1
                },
                function () {
                    console.log("Channel created: Sendy");
                },
                function (error) {
                    console.log("Create channel error: " + error);
                });

            window.FirebasePlugin.onMessageReceived(function (message) {
                handleNotificationMessage(message, message && message.tap);
            }, function (error) {
                console.log("Failed receiving FirebasePlugin message", error);
            });
        }
    };
});

